import { useContext } from 'react';
import { I18nContext, type I18nContextValue } from './I18nProvider';

/** Everything i18n: `t`, the active locale, and the `Intl` formatters. */
export function useI18n(): I18nContextValue {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used inside <I18nProvider>');
  return ctx;
}

export function useOptionalI18n(): I18nContextValue | null {
  return useContext(I18nContext);
}

/** Shorthand for the common case. */
export function useT(): I18nContextValue['t'] {
  return useI18n().t;
}
